import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Cell, CellDropdownOptions } from 'src/app/models';

/**
 * Component used for cell type cella_dropdown in the tables of subtool 4 of NLL
 */

@Component({
    selector: 'app-cell-dropdown',
    templateUrl: './cell-dropdown.component.html',
    styleUrls: ['./cell-dropdown.component.scss'],
    standalone: false
})
export class CellDropdownComponent implements OnInit, OnChanges {

  @Input() data: Cell;
  @Output() sendSelectedCellValue: EventEmitter<Cell> = new EventEmitter();
  @Output() isDropdownClosed: EventEmitter<boolean> = new EventEmitter();
  selected: string;

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.data) {
      this.getSelected();
    }
  }

  onChange() { }

  /**
   * Save the id of the selected option in the cell dropdown
   */

  getSelected() {
    this.selected = this.data.options.filter(option => option.is_selected)[0].id;
  }

  /**
   * Updates cell information when selecting a dropdown value
   * @param event Cell whose dropdown value is selected
   */

  updateSelected(event: CellDropdownOptions) {
    let id = null;
    this.data.options.map(option => {
      if (option.id === event.id) {
        option.is_selected = true;
        this.data.value = option.value;
        id = option.id;
      } else {
        option.is_selected = false;
      }
    });
    this.selected = id;
  }

  /**
   * When selecting the value from the dropdown, it updates the information
   * and sends the cell to the parent component
   * @param event Cell whose dropdown value is selected
   */

  onSelect(event: CellDropdownOptions) {
    this.updateSelected(event);
    this.sendSelectedCellValue.emit(this.data);
  }

  /**
   * Send the dropdown open/close status
   * @param status Open/close status
   */

  setDropdownStatus(status: boolean) {
    this.isDropdownClosed.emit(status);
  }
}
